(function () {
	const warmVideo = (video) => {
		if (!video || video.dataset.psmtWarmed === 'true') return;
		video.dataset.psmtWarmed = 'true';
		const needsLoad = video.preload !== 'auto';
		video.preload = 'auto';
		if (needsLoad) video.load();
	};

	const playActiveVideo = (slider) => {
		const activeSlide = slider.slides[slider.activeIndex];
		if (!activeSlide) return;
		const video = activeSlide.querySelector('video');
		if (video) {
			warmVideo(video);
			const playPromise = video.play();
			if (playPromise) playPromise.catch(() => {});
		}

	};

	const pauseAllVideos = (slider) => {
		slider.slides.forEach((slide) => {
			const video = slide.querySelector('video');
			if (video) {
				video.pause();
				video.currentTime = 0;
			}
		});
	};

	const initSliders = () => {
		let productSlider;
		let productSubSlider;
		const productSubSliders = document.querySelectorAll('.swiper-product-slider-movie-tabs-thumbs');
		const productSliders = document.querySelectorAll('.swiper-product-slider-movie-tabs');
		const pagination = document.querySelectorAll('.swiper-product-slider-movie-tabs .swiper-pagination');

		productSliders.forEach((slider, index) => {
			productSubSlider = new Swiper(productSubSliders[index], {
        slidesPerView: 1,
        spaceBetween: 2,
        direction: "horizontal",
        navigation: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        simulateTouch: true,
        allowTouchMove: true,
        preventInteractionOnTransition: true,
        on: {
          touchEnd: function (s, e) {
            let range = 5;
            let diff = (s.touches.diff = s.isHorizontal()
              ? s.touches.currentX - s.touches.startX
              : s.touches.currentY - s.touches.startY);
            if (diff < range || diff > -range) s.allowClick = true;
          },
        },
        breakpoints: {
          750: {
            slidesPerView: 4,
            direction: "vertical",
            freeMode: true,
          },
        },
      });

			productSlider = new Swiper(slider, {
        slidesPerView: 1,
        simulateTouch: true,
        allowTouchMove: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        pagination: {
          el: pagination[index],
          bulletClass: "swiper-bullet",
          bulletActiveClass: "swiper-bullet-active",
          clickable: true,
          renderBullet: function (index, className) {
            return (
              '<span class="' +
              className +
              ' swiper-bullet--svg-animation"><svg width="30" height="30" viewBox="0 0 28 28"><circle class="svg__circle" style="animation-duration: ' +
              this.el.getAttribute("data-duration") +
              's" cx="14" cy="14" r="12" fill="none" stroke-width="2"></circle></svg></span>'
            );
          },
        },
        autoplay: {
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        thumbs: {
          swiper: window.matchMedia("(min-width: 750px)").matches
            ? productSubSlider
            : "",
        },
        breakpoints: {
          990: {
            direction: "vertical",
          },
        },
        on: {
          slideChange: function () {
            this.pagination.render();
            this.pagination.update();
            pauseAllVideos(this);
            playActiveVideo(this);
          },
          afterInit: function () {
            playActiveVideo(this);
          },
          autoplayPause: function () {
            const activeSlide = this.slides[this.activeIndex];
            if (!activeSlide) return;
            const video = activeSlide.querySelector('video');
            if (video) video.pause();
          },
          autoplayResume: function () {
            const activeSlide = this.slides[this.activeIndex];
            if (!activeSlide) return;
            const video = activeSlide.querySelector('video');
            if (video) video.play();
          },
        },
      });

			if (window.matchMedia('(max-width: 749px)').matches) {
				productSubSlider.controller.control = productSlider;
				productSlider.controller.control = productSubSlider;
			}
		});
	};

	const destroySliders = () => {
		const productSubSliders = document.querySelectorAll('.swiper-product-slider-movie-tabs-thumbs');
		const productSliders = document.querySelectorAll('.swiper-product-slider-movie-tabs');

		productSliders.forEach((slider, index) => {
			if (slider.swiper !== undefined) {
				pauseAllVideos(slider.swiper);
				slider.swiper.destroy();
			}
			if (productSubSliders[index].swiper !== undefined) productSubSliders[index].swiper.destroy();
		});
	};

	const initSection = () => {
		destroySliders();
		initSliders();
	};

	initSection();

	// Swiper handles ordinary resizing itself. Rebuild only when the layout mode
	// crosses a breakpoint that changes how the two sliders are connected.
	let layoutMode = window.innerWidth < 750 ? 'mobile' : window.innerWidth < 990 ? 'tablet' : 'desktop';
	let resizeTimer;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			const nextLayoutMode = window.innerWidth < 750 ? 'mobile' : window.innerWidth < 990 ? 'tablet' : 'desktop';
			if (nextLayoutMode === layoutMode) return;
			layoutMode = nextLayoutMode;
			initSection();
		}, 150);
	});

	document.addEventListener('shopify:section:load', function () {
		initSection();
	});
})();
